import React, {useContext} from "react";

import {RowDivF1} from "../../styledComponents/CustomStyledComponents";
import {CountryPathAndReportProps} from "../../../interfaces/RankingsAndLevelsInterfaces";
import CountryInfo from "./CountryInfo";
import {GlobalDataContext} from "../../../contexts/GlobalDataContext";
import {StyledSkeletonCircle} from "../../SkeletonLoader/SkeletonLoaders";
import withLoadingAnimation from "../../AnimationWrapper/AnimationWrapper";
import '../CountryStyles.css';
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import Colors from "../../../assets/colors/Colors";

const CountrySVG: React.FC<{countryInfo: any}> = ({countryInfo}) => {
    // @ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);
    return (
        <svg width='80%' height='80%' viewBox='0 0 100 100'>
            <path
                d={countryInfo.path || ''}
                className='countrySvg'
                fill={isLife ? Colors.fontWhite : Colors.fontGray}
                stroke={isLife ? Colors.fontWhite : Colors.fontGray}
            />
        </svg>
    )
};

const CountryComponent: React.FC<{countryInfo: CountryPathAndReportProps | undefined}> = ({countryInfo = {}}) => {
    // @ts-ignore
    const { allDataLoaded } = useContext(GlobalDataContext);

    return (
        <RowDivF1>
            <div className='countrySvgWrapper'>
                {
                    withLoadingAnimation(
                        <CountrySVG countryInfo={countryInfo}/>,
                        <StyledSkeletonCircle
                            customStyle={{display: "flex", justifyContent: "center", alignItems: "center", height: '70%'}}
                        />,
                        allDataLoaded
                    )
                }
            </div>
            <CountryInfo countryInfo={countryInfo.countryReportData} />
            <div style={{flex: 0.4}}/>
        </RowDivF1>
    )
};

export default CountryComponent;

export { CountrySVG };
